/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slot_No_TimeInputs */

const en_slot_no_time = /** @type {(inputs: Slot_No_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No time`)
};

const de_slot_no_time = /** @type {(inputs: Slot_No_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Uhrzeit`)
};

/**
* | output |
* | --- |
* | "No time" |
*
* @param {Slot_No_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_no_time = /** @type {((inputs?: Slot_No_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_No_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_no_time(inputs)
	return en_slot_no_time(inputs)
});